import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import banners from '@gin-betting/banners';
import { BannerZoneLocation } from '@gin-betting/constants';

import { ParentPath } from 'types';
import ui from 'modules/ui';
import { useMemoSelector } from 'hooks';
import { extractParentRouteFromHistory } from 'utils';

const {
    actions: { openMobileTopMatches },
    selectors: { selectIsMobileTopMatchesOpened },
} = ui;

const {
    selectors: { makeBannerZonesAvailabilitySelector },
} = banners;

const pageLocations = [
    BannerZoneLocation.TOP_SPORT_EVENTS,
    BannerZoneLocation.POPULAR_SPORT_EVENTS,
    BannerZoneLocation.FAVORITES_SPORT_EVENTS,
];

const attributes = pageLocations.map(pageLocation => ({ pageLocation }));

interface Output {
    route: ParentPath;
    isMobileTopMatchesVisible: boolean;
    isMobileTopMatchesOpened: boolean;
    handleOpenMobileTopMatches: VoidFunction;
}

const useTopMobileTitle = (): Output => {
    const dispatch = useDispatch();

    useLocation();

    const route = extractParentRouteFromHistory();

    const isMobileTopMatchesOpened = useMemoSelector(
        selectIsMobileTopMatchesOpened
    );

    const isMobileTopMatchesVisible = useMemoSelector(
        makeBannerZonesAvailabilitySelector(attributes),
        {}
    );

    const handleOpenMobileTopMatches = () => {
        dispatch(openMobileTopMatches());
    };

    return {
        route,
        isMobileTopMatchesVisible,
        isMobileTopMatchesOpened,
        handleOpenMobileTopMatches,
    };
};

export default useTopMobileTitle;
